import { useStore } from '@/store';
import { ReevaluateModal } from './reevaluate-modal';
import { useIteratorWatcher } from './use-iterator-watcher';

/**
 * Re-evaluation in the editor: the dialog, plus the watcher that marks
 * fields stale when an iterator changes.
 */
export const Reevaluation = () => {
  useIteratorWatcher();
  const [opened, setOpened] = useStore(({ ai }) => [
    ai.reevaluateOpen,
    ai.setReevaluateOpen,
  ]);

  return <ReevaluateModal opened={opened} onClose={() => setOpened(false)} />;
};
